import React from 'react';
import PropTypes from 'prop-types';

import Grid from 'shared-components/components/Grid';
import GridItem from 'shared-components/components/GridItem';

import HpArrow from 'shared-vectors/icons/HpArrow';
import { Icon } from 'shared-vectors';

import { queryBuilder } from '@modals/factories';

import { useCtxGlobal } from '@client/app/Container';

import { ALL_PROPERTY_TYPE_VALUES } from 'shared-constants/src/filters';

import SearchBlock from '../SearchBlock';

const PTypes = ({
  availableResults,
  propertyTypes,
  licenseTypeGroups,
}) => {
  const {
    isMobile,
    isSmallMobile,
    openModal,
    pageType,
    filtersProps,
  } = useCtxGlobal();

  const choose = () => openModal && openModal(queryBuilder({
    isMobile,
    isSmallMobile,
    availableResults,
    pageType,
    filtersProps,
    panelChooseBy: {
      isMobile,
      actionClicked: 'propertyTypeGroupSelect',
      pageFrom: pageType,
    },
  }));

  const displayTypes = propertyTypes.map(function(pt) {
    const match = ALL_PROPERTY_TYPE_VALUES && ALL_PROPERTY_TYPE_VALUES.find(function(v) { return v.slug.replace(/\+/g, '-') === pt || v.display === pt; });
    return match ? match.display : pt;
  });

  const arrToUse = licenseTypeGroups && licenseTypeGroups.length && displayTypes.length === 1 && displayTypes[0] === 'Attività/Licenza (con o senza mura)'
    ? licenseTypeGroups
    : displayTypes;

  const onKeyPress = (e) => {
    if (e.key === 'Enter') {
      choose();
    }
  };    
  
  return (
    <SearchBlock
      label="Cerco"
      button={arrToUse[0]}
      onClickAction={choose}
      onKeyPressAction={onKeyPress}
      className="sentenceElement"
      icon={<Icon aria-hidden="true" name={HpArrow} width="12px" height="7px" className="is-anim mb--xs" fill />}
      ariaLabel={`Cerco ${arrToUse[0]}${arrToUse.length > 1 ? ` e ${arrToUse.length - 1} altri` : ''}. Clicca per cambiare tipologia immobile`}        
      ariaHaspopup="dialog"
      more={arrToUse.length > 1 ? `+${arrToUse.length - 1}` : ''}
    />    
  );
};

export default PTypes;

PTypes.propTypes = {
  propertyTypes: PropTypes.instanceOf(Array),
  licenseTypeGroups: PropTypes.instanceOf(Array),
  availableResults: PropTypes.string,
};

PTypes.defaultProps = {
  propertyTypes: [],
  licenseTypeGroups: [],
  availableResults: '0',
};
